<template lang="pug">
.t-content
  promoContent(:target="true" @getList="getList" ref="promo")
  //- #modal-promo01.modal.fade(tabindex='-1' aria-hidden='true')
  //-   .modal-dialog.modal-lg.modal-dialog-centered.modal-dialog-scrollable
  //-     .modal-content
  //-       template(v-if="promoSelected.length > 0")
  //-         template(v-if="getLanguage==='zh'")
  //-         template(v-else-if="getLanguage==='my'")
  //-         template(v-else)
  //-           .modal-header
  //-             h5.modal-title(v-html="promoSelected[0].en_title")
  //-             button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
  //-               i.fa-solid.fa-xmark
  //-           .modal-body
  //-             .text-center
  //-               img(:src='imgUrl+promoSelected[0].en_image_url')
  //-             .py-3(v-html="promoSelected[0].en_body")
  section.info-sec
    .max-container
      .filter-box
        .filter-menu
          .pmbox.filter(href='javascript:void(0)' :class="{'active': selectedDisplay === 'ALL'}" @click="changeDisplay('ALL')") {{$t('ui.all')}}
          .pmbox.filter(href='javascript:void(0)' :class="{'active': selectedDisplay === 'SLOTS'}" @click="changeDisplay('SLOTS')") {{$t('ui.slots')}}
          .pmbox.filter(href='javascript:void(0)' :class="{'active': selectedDisplay === 'LIVE CASINO'}" @click="changeDisplay('LIVE CASINO')") {{$t('ui.livecasino')}}
          .pmbox.filter(href='javascript:void(0)' :class="{'active': selectedDisplay === 'WELCOME BONUS'}" @click="changeDisplay('WELCOME BONUS')") {{$t('ui.bonus_welcome')}}
          .pmbox.filter(href='javascript:void(0)' :class="{'active': selectedDisplay === 'REFERRAL BONUS'}" @click="changeDisplay('REFERRAL BONUS')") {{$t('ui.bonus_referral')}}
        .promo-content-area
          template(v-for="promo in promoList")
            //- .promo-bx.ppb(:class="{'d-none': selectedDisplay != 'ALL' && promo.category != selectedDisplay}")
            .promo-bx.ppb(v-show="selectedDisplay == 'ALL' || promo.category == selectedDisplay")
              .promo-item
                template(v-if="getLanguage==='zh'")
                  .promo-pic
                    .promo-more-info
                      a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                        i.fas.fa-info-circle
                    img.w-100.img-fluid(:src='imgUrl+promo.cn_image_url')
                    .promo-detail-wrapper(v-if="promo.cn_preview1_title")
                      .promo-detail-col(v-if="promo.cn_preview1_title")
                        .promo-info-title {{promo.cn_preview1_title}}
                        .promo-info-amount {{promo.cn_preview1_content}}
                      .promo-detail-col(v-if="promo.cn_preview2_title")
                        .promo-info-title {{promo.cn_preview2_title}}
                        .promo-info-amount {{promo.cn_preview2_content}}
                      .promo-detail-col(v-if="promo.cn_preview3_title")
                        .promo-info-title {{promo.cn_preview3_title}}
                        .promo-info-amount {{promo.cn_preview3_content}}
                  .promo-btn-wrap
                    a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                      button.btn-submit.btn-more {{$tc('ui.more_info')}}
                    router-link(v-if="$store.getters.isLoggedIn" to="/deposit")
                      button.btn-submit {{$tc('ui.claim_offer')}}
                    router-link(v-else to="/login")
                      button.btn-submit {{$tc('ui.claim_offer')}}
                template(v-else-if="getLanguage==='my'")
                  .promo-pic
                    .promo-more-info
                      a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                        i.fas.fa-info-circle
                    img.w-100.img-fluid(:src='imgUrl+promo.mys_image_url')
                    .promo-detail-wrapper(v-if="promo.mys_preview1_title")
                      .promo-detail-col(v-if="promo.mys_preview1_title")
                        .promo-info-title {{promo.mys_preview1_title}}
                        .promo-info-amount {{promo.mys_preview1_content}}
                      .promo-detail-col(v-if="promo.mys_preview2_title")
                        .promo-info-title {{promo.mys_preview2_title}}
                        .promo-info-amount {{promo.mys_preview2_content}}
                      .promo-detail-col(v-if="promo.mys_preview3_title")
                        .promo-info-title {{promo.mys_preview3_title}}
                        .promo-info-amount {{promo.mys_preview3_content}}
                  .promo-btn-wrap
                    a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                      button.btn-submit.btn-more {{$tc('ui.more_info')}}
                    router-link(v-if="$store.getters.isLoggedIn" to="/deposit")
                      button.btn-submit {{$tc('ui.claim_offer')}}
                    router-link(v-else to="/login")
                      button.btn-submit {{$tc('ui.claim_offer')}}
                template(v-else)
                  .promo-pic
                    .promo-more-info
                      a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                        i.fas.fa-info-circle
                    img.w-100.img-fluid(:src='imgUrl+promo.en_image_url')
                    .promo-detail-wrapper(v-if="promo.en_preview1_title")
                      .promo-detail-col(v-if="promo.en_preview1_title")
                        .promo-info-title {{promo.en_preview1_title}}
                        .promo-info-amount {{promo.en_preview1_content}}
                      .promo-detail-col(v-if="promo.en_preview2_title")
                        .promo-info-title {{promo.en_preview2_title}}
                        .promo-info-amount {{promo.en_preview2_content}}
                      .promo-detail-col(v-if="promo.en_preview3_title")
                        .promo-info-title {{promo.en_preview3_title}}
                        .promo-info-amount {{promo.en_preview3_content}}
                  .promo-btn-wrap
                    a(href='javascript:void(0);' @click="viewPromo(promo.id)")
                      button.btn-submit.btn-more {{$tc('ui.more_info')}}
                    router-link(v-if="$store.getters.isLoggedIn" to="/deposit")
                      button.btn-submit {{$tc('ui.claim_offer')}}
                    router-link(v-else to="/login")
                      button.btn-submit {{$tc('ui.claim_offer')}}
</template>
<script>
import config from "@/config";
import promoContent from "@/components2/promotionTable/_promoContent.vue"
export default {
  // metaInfo: {
  //   title: 'Best Online Casino Bonus & Promotions at Epicwin | Claim Free Kredit RM10',
  //   // meta:[
  //   //   {vmid: "description",name: 'description', content: "Epicwin is the best online casino site for online casino bonuses and promotions, including a free credit of RM10!"}
  //   // ],
  //   // script: [{
  //   //   vmid: 'ldjson-schema',
  //   //   type: 'application/ld+json',
  //   //   json: {
  //   //     "@context": "https://schema.org",
  //   //     "@type": "FAQPage",
  //   //     "mainEntity": [{
  //   //       "@type": "Question",
  //   //       "name": "How do I sign up for an account?",
  //   //       "acceptedAnswer": {
  //   //         "@type": "Answer",
  //   //         "text": "You can sign up for an account by clicking on the \"Sign Up\" button on the home page."
  //   //       }
  //   //     },{
  //   //       "@type": "Question",
  //   //       "name": "What information do I need to provide when signing up?",
  //   //       "acceptedAnswer": {
  //   //         "@type": "Answer",
  //   //         "text": "When signing up, you will be asked to provide your name, email address, and password. You will also need to agree to the Terms and Conditions and Privacy Policy."
  //   //       }
  //   //     },{
  //   //       "@type": "Question",
  //   //       "name": "How do I redeem my free credit RM10?",
  //   //       "acceptedAnswer": {
  //   //         "@type": "Answer",
  //   //         "text": "To redeem your free credit RM, simply login to your account and go to the \"Banking\" section. From there, you will be able to select the amount of credit you would like to redeem."
  //   //       }
  //   //     }]
  //   //   }
  //   // }]
  // },
  components:{
    promoContent
  },
  data(){
    return{
      selectedDisplay: 'ALL',
      feedback: {
        success: true,
        status: ""
      },
      promoList: [],
			promoSelected: [],
      loading:false,
			imgUrl: config.imageUrl,
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
	},
  created(){
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/promotions');
  },
  mounted(){
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    getList(e){
			this.promoList = e
		},
    changeDisplay(target){
      this.selectedDisplay = target
    },  
    viewPromo(id){
			this.$refs.promo.showPromo(id, 1)
		},
  }
}
</script>
<style lang="scss" scoped>
.btn-container{
  margin: 0 auto
}
.btn-submit{
  width: 165px;
  font-size: 14px;
  padding: 0;
  @media(min-width: 681px){
    width: 200px;
    font-size: 16px;
  }
  @media (min-width: 1441px ) and (max-width: 1629px){
    width: 180px;
  }
}
.btn-more {
  color: #ffffff;
  border-color: #a403ff;
  background: linear-gradient(180deg, #a500fb 0%, #4e01b3 100%);
}
.ct-right{
  margin: 0.5rem;
  @media (min-width: 681px ) and (max-width: 913px){
    margin: 0;
  }
}
</style>